import React from 'react'
import { Link as MUILink } from '@mui/material'
import { StyledLink } from './components'

interface LinkProps {
  linkText?: string
  underline?: 'none' | 'hover' | 'always'
  href?: string
  onClick?: (e: React.MouseEvent) => void
}
function Link({ linkText, underline = 'none', href = '#', onClick }: LinkProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault()
      onClick(e)
    }
  }

  return (
    <MUILink underline={underline} href={href} onClick={handleClick}>
      <StyledLink>{linkText}</StyledLink>
    </MUILink>
  )
}

export default Link
